import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { MoveShiftsResponse } from '@wilson/api/gateway';
import { AuthorizationModule } from '@wilson/authorization';
import { RoleAction, RolePermissionSubject, Shift } from '@wilson/interfaces';
import { MoveShiftHelperService } from '@wilson/non-domain-specific/shift-helpers/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
@Component({
  selector: 'wilson-move-single-shift-action',
  imports: [TranslatePipe, NzTooltipModule, NzMenuModule, AuthorizationModule],
  templateUrl: './move-single-shift-action.component.html',
  styleUrl: './move-single-shift-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoveSingleShiftActionComponent {
  private readonly moveShiftHelperService = inject(MoveShiftHelperService);

  @Input({
    required: true,
  })
  isMoveAllowed = false;

  @Input({
    required: true,
  })
  shift!: Shift;

  @Output() moveShiftSuccess = new EventEmitter<MoveShiftsResponse>();

  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  async triggerDurationSelectionModal(): Promise<void> {
    const result = await this.moveShiftHelperService.openDurationSelectionModal(
      [this.shift],
    );
    if (result) {
      this.moveShiftSuccess.emit(result);
    }
  }
}
